import { useForm } from 'react-hook-form';
import { useCallback, useEffect, useRef } from 'react';
import { ComposerMode } from '../types/index';
export function useEventComposerForm(initialFormValues, composerMode) {
    var methods = useForm({
        defaultValues: initialFormValues,
        mode: 'onChange',
    });
    var hasInitialized = useRef(false);
    var lastEventId = useRef();
    var lastUid = useRef();
    // Reset form when we get new event data (for both create and edit composerMode)
    // This is important for shell app architecture where props may arrive with delays
    useEffect(function () {
        var hasMeaningfulValues = initialFormValues && Object.keys(initialFormValues).length > 0;
        if (!hasMeaningfulValues)
            return;
        if (composerMode === ComposerMode.EDIT) {
            var currentEventId = initialFormValues.eventId;
            var hasEventId = currentEventId && currentEventId !== '';
            var isNewEvent = hasEventId && currentEventId !== lastEventId.current;
            // Only reset if:
            // 1. We have meaningful initial values (not just empty object)
            // 2. We haven't initialized yet OR this is a new event
            // 3. We have an eventId (indicating this is edit composerMode with fetched data)
            if (hasEventId && (isNewEvent || !hasInitialized.current)) {
                methods.reset(initialFormValues);
                hasInitialized.current = true;
                lastEventId.current = currentEventId;
            }
        }
        else if (composerMode === ComposerMode.CREATE) {
            // For CREATE mode, check if we have meaningful data (e.g., spaces, title, etc.)
            // This is important for shell app architecture where props may arrive with delays
            var hasSpaces = initialFormValues.spaces && initialFormValues.spaces.length > 0;
            var hasMeaningfulData = hasSpaces ||
                initialFormValues.title ||
                (initialFormValues.startTime && initialFormValues.endTime);
            // Track if we've seen spaces before to detect when they arrive
            var hadSpacesBefore = lastUid.current !== undefined;
            var spacesJustArrived = hasSpaces && !hadSpacesBefore;
            // Only reset if:
            // 1. We have meaningful initial values (not just empty object)
            // 2. We haven't initialized yet OR spaces just arrived (indicating event data has arrived)
            // 3. We have spaces or other meaningful data (indicating event data has arrived)
            if (hasMeaningfulData && (spacesJustArrived || !hasInitialized.current)) {
                methods.reset(initialFormValues);
                hasInitialized.current = true;
                // Track that we've seen spaces to detect future updates
                if (hasSpaces) {
                    lastUid.current = 'initialized';
                }
            }
        }
    }, [initialFormValues, methods, composerMode]);
    // Example: custom submit handler
    var onSubmit = useCallback(function (
    /* @TODO Simple callback to call handleEventCreation, for now. */
    createEventCallback
    // data?: EventComposerFormValues
    ) {
        createEventCallback === null || createEventCallback === void 0 ? void 0 : createEventCallback();
    }, []);
    return {
        methods: methods,
        onSubmit: onSubmit,
    };
}
